import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { userMessage } from '../../../../utils/vy-toasts';
import { isError } from '@vy/utils';
import { MorningExportInvoicesRequestPayload } from '@vy/api-definition';

export function useMorningExportInvoices(
  options?: UseMutationOptions<void, unknown, MorningExportInvoicesRequestPayload>,
) {
  return useMutation({
    mutationKey: ['morningExportInvoices'],
    mutationFn: async ({ invoiceIds }) => {
      const api = getPrivateApi();

      return api.morningExportInvoices({
        morningExportInvoicesRequest: {
          invoiceIds,
        },
      });
    },
    onError: (error) => {
      if (isError(error)) {
        userMessage('error', error.message);
      }
    },
    ...options,
  });
}
